module.exports = __webpack_public_path__ + "img/ltgjy-popup.7714fa2f.jpg";